import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { useFileTokenContext } from "~/components/FilePreview/context/FileTokenContext.js";
import { prepareThumbnailUrl } from "~/utils/utils.jsx";
import { SelectAttachmentsItem } from "./SelectAttachmentsItem.js";
import { getAttachmentById } from "../../store/selectors/selector.attachments.jsx";

export const AttachmentAsListItemContainer = ({ id, onRemove }) => {
  const { download_token, thumb_token } = useFileTokenContext();
  const attachment = useSelector((state) => getAttachmentById(state, id));

  const type = useMemo(() => {
    if (attachment?.isGoogleDriveFile()) {
      return `google`;
    }

    if (attachment?.isDropboxFile()) {
      return `dropbox`;
    }

    if (attachment?.isLocalFile()) {
      return `local`;
    }

    if (attachment?.isWarehouseFile()) {
      return `warehouse`;
    }
  }, [attachment]);

  const thumbnailUrl = useMemo(
    () => prepareThumbnailUrl(attachment?.get(`thumbnail_url`), 60, 60, "crop", thumb_token, download_token),
    [download_token, attachment, thumb_token]
  );

  return (
    <SelectAttachmentsItem
      id={id}
      name={attachment.name}
      type={type}
      thumbnailUrl={thumbnailUrl}
      onRemove={onRemove}
    />
  );
};

AttachmentAsListItemContainer.propTypes = {
  id: PropTypes.number,
  onRemove: PropTypes.func,
};
